<template>
  <div class="video-ai-event-querry">
    <div class="repaly">
      <template v-if="false">
        <div class="blue-title">
          <span>场景视频回放</span>
        </div>
        <el-form id="aiAlarmDetailForm" :inline="true" :model="formData" class="demo-form-inline">
          <el-row>
            <el-form-item prop="factoryId">
              <!-- <el-select
              v-model="formData.factoryId"
              filterable
              placeholder="选择工厂"
              clearable
              @change="getWorkshopByFactory"
            >
              <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select> -->
              <el-input v-model="params.factoryName" disabled></el-input>
              <!-- <el-input v-model="formData.factoryName" disabled></el-input> -->
            </el-form-item>
            <el-form-item prop="workshopId">
              <!-- <el-select
              v-model="formData.workshopId"
              filterable
              clearable
              placeholder="选择车间"
              @change="getSceneByWorkshop"
            >
              <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> -->
              <el-input v-model="params.workshopName" disabled></el-input>
            </el-form-item>
            <el-form-item prop="sceneId">
              <!-- <el-select placeholder="选择场景" v-model="formData.sceneId" clearable filterable>
              <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select> -->
              <el-input v-model="params.sceneName" disabled></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="params.eventStartTime"
                type="datetime"
                placeholder="开始时间"
                disabled
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="params.eventEndTime"
                type="datetime"
                placeholder="结束时间"
                disabled
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <!-- <el-form-item>
            <el-button type="info" @click="onReset">重置</el-button>
          </el-form-item> -->
          </el-row>
        </el-form>
      </template>

      <div class="blue-title event">
        <span>事件视频回放</span>
      </div>

      <div class="event-video-info">
        <div class="info-item" v-for="item in eventVideoInfo" :key="item.label">
          <template v-if="item.type === 'button'">
            <span class="value goback" @click="goBacktoEventList">
              <i class="el-icon-back back-event-list-btn"></i> {{ item.label }}</span
            >
          </template>
          <template v-else>
            <span class="label">{{ item.label }}：</span>
            <span v-if="item?.type === 'select'" class="value">
              <el-select v-model="eventNumber" placeholder="请选择事件编号">
                <el-option v-for="item in eventOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <template v-else>
              <el-tooltip
                popper-class="custom-toolip-class"
                :content="item.value"
                class="item"
                effect="light"
                placement="top-start"
                :disabled="disabledTooltip"
              >
                <span class="value ellipsis" @mouseover="showTip($event)">{{ eventVideoInfoObj[item.value] }}</span>
              </el-tooltip>
            </template>
          </template>
        </div>
      </div>

      <div class="event-videos">
        <div v-for="(item, index) in cameras" :key="`index${index}`" class="video-item item">
          <CustomPlayer
            @setImgUrl="setImgUrlFn"
            :dev-num="item.deviceNum"
            videoType="history"
            :startTime="params.eventStartTime"
            :endTime="params.eventEndTime"
          />
        </div>
      </div>
    </div>

    <div class="review">
      <div class="blue-title">
        <span>事件复核</span>
      </div>

      <div class="main-box">
        <img v-if="imgSrc" :src="imgSrc" alt="" />
        <span v-else>暂无图片</span>
      </div>

      <div class="img-des">
        <el-input v-model="remark" type="textarea" placeholder="截图描述（输入文字，限120字以内）"></el-input>
      </div>

      <div class="operation">
        <el-button type="info" @click="cancleImg">取消</el-button>
        <el-button type="primary" @click="uploadImg">保存</el-button>
      </div>

      <div class="blue-title">
        <span>事件定性判断</span>
      </div>

      <div class="carousel">
        <div v-if="pageConfig.index !== 0" class="circle left" @click="pageLess">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="carousel-item" v-for="item in reviewImages" :key="item.fileId">
          <ImagePreview
            v-if="previewListResource && checkFileSuffix(item.fileSuffix)"
            width="%100"
            :height="80"
            :src="item.url"
            :preview-src-list="[item.url]"
          />
        </div>
        <div
          v-if="pageConfig.index !== totalPages - 1"
          class="circle right"
          :class="[pageConfig.index === 0 ? 'disabled' : '']"
          @click="pageAdd"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="form">
        <el-form :model="ruleForm" label-position="left" label-width="60px" ref="ruleForm" class="rule-form">
          <el-form-item label="AI误判">
            <el-select v-model="ruleForm.reviewResult" placeholder="请选择">
              <el-option label="是" value="ok"></el-option>
              <el-option label="否" value="ai_error"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="事件严重度">
            <el-select v-model="ruleForm.eventLevel" placeholder="请选择">
              <el-option label="严重" value="severe"></el-option>
              <el-option label="一般" value="medium"></el-option>
              <el-option label="轻微" value="low"></el-option>
              <el-option label="可忽略" value="trivial"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="当事人">
            <!-- <el-select v-model="ruleForm.reviewPersonId" placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              ></el-option>
            </el-select> -->
            <el-input v-model="reviewPersonName" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="info">取消</el-button>
            <el-button type="primary" @click="updateEventCamera">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';
import CustomPlayer from '@/components/customPlayer.vue';
import ImagePreview from '@/components/ImagePreview/index.vue';

export default {
  data() {
    return {
      // 查询条件
      formData: {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        eventStartTime: '',
        eventEndTime: '',
        eventType: ''
      },
      params: {
        factoryName: '',
        workshopName: '',
        sceneName: '',
        eventStartTime: '',
        eventEndTime: ''
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      eventVideoInfoObj: {
        eventSence: '',
        eventStartTime: '',
        lang: '',
        eventType: ''
      },
      eventVideoInfo: [
        {
          value: 'eventSence',
          label: '事件场景'
        },
        {
          value: 'eventStartTime',
          label: '发生时间'
        },
        // {
        //   value: '',
        //   label: '更换事件',
        //   type: 'select'
        // },
        {
          value: '',
          label: '返回事件列表',
          type: 'button'
        },
        {
          value: 'lang',
          label: ' 视频时长'
        },
        {
          value: 'eventType',
          label: '事件类型'
        }
      ],
      disabledTooltip: false,
      eventOptions: [
        {
          value: '1',
          label: '事件1'
        },
        {
          value: '2',
          label: '事件2'
        }
      ],
      eventNumber: '',
      cameras: [],
      ruleForm: {
        reviewResult: '',
        eventLevel: ''
      },
      backEventImgs: [],
      reviewImages: [],
      pageConfig: {
        size: 5,
        index: 0
      },
      totalPages: 0,
      testUrl: '',
      imgSrc: '',
      remark: '', // 图片描述
      id: '',
      userList: [],
      detailObj: null,
      reviewPersonName: '',
      previewListResource: false
    };
  },
  components: {
    CustomPlayer,
    ImagePreview
  },
  created() {
    this.id = this.$route.query.id;
    this.getUserList();
    this.getDetail();
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getFactoryByCustomer();
    this.getImgs();
  },
  methods: {
    // 跟新事件视频
    updateEventCamera() {
      const params = {
        id: this.id,
        ...this.ruleForm
      };
      request
        .put(`${api.cAiEventData.delVideoAiEvent}`, params)
        .then((res) => {
          if (res.code === 200) {
            Message.success('更新成功');
          } else {
            Message.error('更新失败');
          }
        })
        .catch((err) => {
          Message.error('更新失败');
        });
    },
    // 获取人员信息
    getUserList() {
      request
        .get(`${api.cAiEventData.getUserList}`)
        .then((res) => {
          if (res.code === 200) {
            this.userList = res.rows.map((item) => {
              return {
                userId: item.userId,
                userName: item.userName
              };
            });
          }
        })
        .catch((err) => {});
    },
    // 取消上传图片
    cancleImg() {
      this.imgSrc = '';
      this.remark = '';
    },
    // 上传图片
    uploadImg() {
      if (!this.imgSrc) {
        return;
      }
      const params = {
        eventId: this.id,
        base64File: this.imgSrc,
        remark: this.remark
      };
      request
        .put(`${api.cAiEventData.uploadBase64}`, params)
        .then((res) => {
          if (res.code === 200) {
            this.freshImg();
            this.$message.success('截图上传成功');
          }
        })
        .catch((err) => {
          this.$message.error('截图上传失败');
        });
    },
    // 刷新图片
    freshImg() {
      if (!this.id) {
        return;
      }
      request.get(`${api.cAiEventData.getEventCameraDetail}/${this.id}`).then((res) => {
        if (res.code === 200 && res.data) {
          this.detailObj = res.data || null;
          let fileIds = this.detailObj.reviewImages.map((item) => item.fileId);
          this.getReviewImgs(fileIds);
        }
      });
    },
    // 返回Ai事件列表
    goBacktoEventList() {
      this.$router.push('/monitor-data/video-aievent-query');
    },
    getDetail() {
      if (!this.id) {
        return;
      }
      request.get(`${api.cAiEventData.getEventCameraDetail}/${this.id}`).then((res) => {
        if (res.code === 200 && res.data) {
          this.detailObj = res.data || null;
          for (let key in this.params) {
            // this.formData[key] = res.data[key] || '';
            this.params[key] = res.data[key] || '';
            this.cameras = res.data.deviceNums.split(',').map((item) => {
              return {
                deviceNum: item
              };
            });
          }
          this.eventVideoInfoObj = {
            eventSence: `${this.detailObj?.factoryName || ''}-${this.detailObj?.workshopName || ''}-${
              this.detailObj?.sceneName || ''
            }`,
            eventStartTime: this.detailObj?.eventStartTime || '',
            lang: this.calculateDuration(this.detailObj?.eventStartTime, this.detailObj?.eventEndTime),
            eventType: this.detailObj?.eventType || ''
          };
          this.ruleForm = {
            reviewResult: this.detailObj?.reviewResult,
            eventLevel: this.detailObj?.eventLevel
          };
          this.reviewPersonName = this.detailObj?.reviewPersonName;
          let fileIds = this.detailObj.reviewImages.map((item) => item.fileId);
          this.getReviewImgs(fileIds);
        } else {
          this.detailObj = null;
          this.cameras = [];
          this.params = {
            factoryName: '',
            workshopName: '',
            sceneName: '',
            eventStartTime: '',
            eventEndTime: ''
          };
          this.eventVideoInfoObj = { eventSence: '', eventStartTime: '', lang: '', eventType: '' };
          this.ruleForm = {
            reviewResult: '',
            eventLevel: ''
          };
          this.reviewPersonName = '';
        }
      });
    },
    checkFileSuffix(fileSuffix) {
      const arr = ['.png', '.jpg', '.jpeg'];
      const suffixArray = Array.isArray(fileSuffix) ? fileSuffix : [fileSuffix];
      return suffixArray.some((suffix) => arr.includes(suffix.toLowerCase()));
    },
    // 获取图片
    getReviewImgs(fileIds) {
      if (!fileIds.length) {
        return;
      }
      request
        .get(`${api.cAiEventData.getImgsUrl}/${fileIds.join(',')}`)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.previewListResource = true;
            const { data } = res;
            this.backEventImgs = this.detailObj.reviewImages.map((item) => {
              const matchedData = data.find((file) => file.ossId === item.fileId);
              if (matchedData) {
                return {
                  fileSuffix: matchedData.fileSuffix,
                  url: matchedData.url,
                  ...item
                };
              } else {
                return {
                  ...item,
                  url: ''
                };
              }
            });
            console.log(this.backEventImgs);
            this.getImgs();
          } else {
            this.previewListResource = false;
          }
        })
        .catch((err) => {
          this.previewListResource = false;
        });
    },
    // 计算事件间隔
    calculateDuration(start, end) {
      let startTime = new Date(start);
      let endTime = new Date(end);
      const durationMs = endTime - startTime;

      const seconds = Math.floor(durationMs / 1000);
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      // 格式化为两位数
      const formatNumber = (num) => num.toString().padStart(2, '0');

      return `${formatNumber(hours)}小时${formatNumber(minutes)}分钟${formatNumber(secs)}秒`;
    },
    setImgUrlFn(url) {
      this.imgSrc = url;
    },
    getURl() {
      this.testUrl = 'http://139.9.219.170:38080/live/camera2025062201.flv';
    },
    getImgs() {
      this.totalPages = Math.ceil(this.backEventImgs.length / this.pageConfig.size);
      this.reviewImages = this.backEventImgs.slice(
        this.pageConfig.index * this.pageConfig.size,
        (this.pageConfig.index + 1) * this.pageConfig.size
      );
    },
    pageLess() {
      if (this.pageConfig.index === 0) {
        return;
      }
      this.pageConfig.index--;
      this.getImgs();
    },
    pageAdd() {
      if (this.pageConfig.index >= this.totalPages - 1) {
        return;
      }
      this.pageConfig.index++;
      this.getImgs();
    },
    showTip(event) {
      this.disabledTooltip = event.target.scrollWidth <= event.target.clientWidth;
    },
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      // 你可以在这里添加你的处理代码
      let dom = document.getElementById('aiAlarmDetailForm');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 191 - formH; //表单的高度会变化

      if (this.lineChart) {
        this.lineChart.resize();
      }
    },
    // 查询
    onSubmit() {
      this.getDetail();
    },
    // 重置
    onReset() {
      this.formData = {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        alarmStartTime: '',
        alarmEndTime: ''
      };
      this.getDetail();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store
        .dispatch('workshop/getFactoryByCustomer')
        .then((result) => {
          if (result.code === 200 && result.data.length) {
            this.factoryOptions = result.data;
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store
        .dispatch('scene/getWorkshopByFactory', { factoryId: this.formData.factoryId })
        .then((result) => {
          this.formData.workshopId = '';
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.workshopOptions = result.data;
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.formData.workshopId })
        .then((result) => {
          this.formData.sceneId = null;
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        })
        .catch((err) => {
          this.sceneOptions = [];
        });
    },
    refreshTable() {
      this.getDetail();
    }
  }
};
</script>

<style lang="scss" scoped>
.video-ai-event-querry {
  border-radius: 3px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
  padding: 10px;

  min-height: calc(100% - 40px);

  display: flex;
  flex-wrap: nowrap;

  .el-form-item {
    margin-bottom: 0;
  }
}
.repaly {
  background-color: #fff;
  width: 70%;
  border-radius: 2px;
  padding: 10px;
  margin-right: 10px;
  .el-form {
    padding: 0 0 15px 0;
  }
}
.review {
  background-color: #fff;
  width: 30%;
  border-radius: 2px;
  padding: 10px;
  .main-box {
    height: 165px;
    width: 100%;
    padding-bottom: 3px;
    border: 1px solid #c1c1c1;
    text-align: center;
    line-height: 165px;
    color: #c1c1c1;
    font-size: 14px;
    border-radius: 4px;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .img-des {
    padding-bottom: 11px;

    :deep(.el-textarea__inner) {
      height: 94px;
      font-size: 12px;
      color: #1c1c1c;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
  }

  .carousel {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    position: relative;
    &:hover {
      .circle {
        opacity: 1;
      }
    }

    .circle {
      position: absolute;

      transform: translateY(-50%);

      flex-shrink: 1;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;
      background-color: royalblue;

      opacity: 0;
      color: #fff;

      &.left {
        left: 0;
        top: 50%;
      }

      &.right {
        right: 0;
        top: 50%;
      }
    }

    .carousel-item {
      width: calc((100% - 12px) / 5);
      height: 80px;
      border: 1px solid #ccc;
      border-radius: 5px;
      img {
        width: 100%;
        height: 100%;
      }

      &:not(:last-child) {
        margin-right: 3px;
      }
    }
  }

  :deep(.el-form).rule-form {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 0;
    .el-form-item {
      width: calc((100% - 16px) / 2);
      margin-right: 0;
      margin-bottom: 20px;

      .el-form-item__label {
        font-size: 12px;
        color: #707070;
      }
      &:nth-child(1) {
        margin-right: 16px;
      }
      &:nth-child(2) {
        .el-form-item__label {
          width: 90px !important;
        }

        .el-form-item__content {
          margin-left: 90px !important;
          width: calc(100% - 90px);
        }
      }
      &:nth-child(3) {
        width: 100%;
      }
      &:nth-child(4) {
        width: 100%;
        display: flex;
        justify-content: center;
        .el-form-item__content {
          width: unset;
        }
      }

      .el-select {
        width: 100%;
      }
    }
  }
}
.blue-title {
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 2px;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 17px;
    background-color: #3083fb;
    margin-right: 4px;
  }
}
.event-video-info {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .info-item {
    display: flex;
    flex-wrap: nowrap;
    width: calc(100% / 3);
    line-height: 20px;
    font-size: 12px;
    .label {
      min-width: 80px;
      color: #707070;
    }
    .value {
      flex: 1;
      padding-right: 10px;
      color: #1c1c1c;
      &.goback {
        cursor: pointer;
      }

      .el-select {
        width: 100%;
      }
    }

    // &:nth-child(4) {
    //   width: 12%;
    // }
  }
}

.event-videos {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100vh - 160px);
  overflow: auto;

  .video-item {
    width: calc((100% - 15px) / 2);
    height: calc((100% - 15px) / 2);

    background-color: #000;

    &:nth-child(odd) {
      margin-right: 15px;
    }
    &:not(:nth-last-child(-n + 2)) {
      margin-bottom: 15px;
    }
  }
  .video-player-container {
    width: 100%;
    height: 100%;
    position: relative;

    .video-player {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:hover {
      .player-controls {
        opacity: 1;
      }
    }
  }
}

.control-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin: 0 15px;
  padding: 5px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.fullscreen-btn {
  }
}

.vertical-volume-slider {
  -webkit-appearance: none;
  width: 6px;
  height: 100px;
  background: linear-gradient(to top, #4a90e2, #1ecb80); /* 渐变轨道，从下到上 */
  border-radius: 3px;
  outline: none;
  opacity: 1;
  transform: rotate(0deg); /* 不需要旋转180度了 */
  writing-mode: bt-lr;
  -webkit-appearance: slider-vertical;

  /* 滑块手柄样式 */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    margin-top: -8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.player-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  transition: opacity 0.3s;
  z-index: 10;

  .play-tools {
    display: flex;
    align-items: center;
  }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.back-event-list-btn {
  font-size: 20px;
  color: #0174f7;
}
</style>
<style lang="scss">
.volume-popper.el-popper {
  min-width: unset;
  .popper__arrow {
    display: none;
  }
}
</style>
